import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["ticketWrapper", "ticketsContainer", "ticketSwiperGroup"];
  connect() {}

  setSelected(e) {
    const activeClassTag = "c-tag-tag--primary";
    const baseClass = "c-tag-tag--on-surface";
    const activeClass = "c-ticket-ticket--active";

    const activeElementsTags = this.ticketSwiperGroupTarget.querySelectorAll(
      "." + activeClassTag
    );
    const activeElementsTicket = this.ticketSwiperGroupTarget.querySelectorAll(
      "." + activeClass
    );

    const currentTicket = e.currentTarget;
    currentTicket.classList.add(activeClass);
    this.clearActiveStatesTags(activeElementsTags, activeClassTag, baseClass);
    this.clearActiveStatesTickets(activeElementsTicket, activeClass);
  }

  clearActiveStatesTags(activeElementsTags, activeClassTag, baseClass) {
    if (!!activeElementsTags) {
      activeElementsTags.forEach((tag) => {
        tag.classList.remove(activeClassTag);
        tag.classList.add(baseClass);
      });
    }
  }

  clearActiveStatesTickets(activeElementsTicket, activeClass) {
    if (!!activeElementsTicket) {
      activeElementsTicket.forEach((ticket) => {
        ticket.classList.remove(activeClass);
      });
    }
  }
}
